/* 모델 포트의 형. 엔진은 이 포트 하나로만 모델에게 묻고, 포트는 MCP 호스트 모델이 pipeline_start 와 pipeline_submit 으로 응답하는 대기 포트다(web/src/pipeline.ts). 서버와 화면은 모델을 직접 부르지 않는다 */

export type Role = 'system' | 'user' | 'assistant';

export interface ChatMessage {
  role: Role;
  content: string;
  thinking?: string;
  // 비전 모델에 주는 그림(base64, 머리 없이)
  images?: string[];
}

interface StreamChunk {
  message?: { role?: string; content?: string; thinking?: string };
  done?: boolean;
  done_reason?: string;
  prompt_eval_count?: number;
  eval_count?: number;
  error?: string;
}

export interface RoundStats {
  evalCount?: number;
  promptEvalCount?: number;
  doneReason?: string;
}

export interface ChatOptions {
  /** 단계 이름. 모델 포트가 응답자에게 어느 단계의 요청인지 알린다(Ollama 는 쓰지 않는다) */
  label?: string;
  signal: AbortSignal;
  think: boolean;
  // Ollama 구조화 출력. JSON 스키마를 주면 content 가 그 스키마의 JSON 으로만 온다
  format?: Record<string, unknown>;
  // 생성 토큰 상한(Ollama options.num_predict). 0 이면 Ollama 기본값
  numPredict?: number;
}

export const seconds = (ms: number) => `${(ms / 1000).toFixed(1)}초`;

/** 스트림 한 줄씩. thinking 과 content 는 조각으로 온다 */
export type ModelPort = (
  messages: ChatMessage[],
  options: ChatOptions,
  onThinking: (text: string) => void,
  onContent: (text: string) => void,
) => Promise<ChatMessage & RoundStats & { thinking: string }>;
